/* GENERERET -- ret ikke i haanden.
   Kilde: theme/sections/NF-design-din-ramme-claudev2.liquid
   Generator: scripts/build_frame_pattern_swatches.mjs

   Rammesidens egne moensterproever, ordret. City Builder viser dem i
   rammevaelgeren, saa de to sider tegner det samme moenster. */
(() => {
  'use strict';

  function woodGrain(bg, ln, n) {
    let s = `<rect width="60" height="60" fill="${bg}"/>`;
    for (let i = 0; i < n; i++) {
      const y = 4 + i * (54 / (n - 1));
      const dx = (i % 2 ? 1.5 : -1.5);
      const w = 0.7 + (i % 3 === 0 ? 0.6 : 0);
      s += `<line x1="0" y1="${y.toFixed(1)}" x2="60" y2="${(y+dx).toFixed(1)}" stroke="${ln}" stroke-width="${w}" opacity="${(0.35+0.2*(i%3===1?1:0)).toFixed(2)}"/>`;
    }
    return s;
  }
  function marblePat(bg, vein) {
    return `<rect width="60" height="60" fill="${bg}"/>`
      + `<path d="M-3 12 C14 6, 22 22, 34 16 S 54 8, 63 14" fill="none" stroke="${vein}" stroke-width="1.1" opacity="0.7"/>`
      + `<path d="M-2 34 C10 40, 26 28, 38 36 S 55 42, 62 34" fill="none" stroke="${vein}" stroke-width="0.8" opacity="0.55"/>`
      + `<path d="M8 62 C14 48, 30 52, 36 44 S 50 30, 58 26" fill="none" stroke="${vein}" stroke-width="0.6" opacity="0.45"/>`;
  }

  function hoerPat() {
    let s = `<rect width="60" height="60" fill="#E6DFD2"/>`;
    for (let i = 0; i < 15; i++) {
      const p = 2 + i * 4;
      s += `<line x1="0" y1="${p}" x2="60" y2="${p}" stroke="#C9BFA9" stroke-width="1" opacity="0.6"/><line x1="${p}" y1="0" x2="${p}" y2="60" stroke="#D5CCB8" stroke-width="1" opacity="0.5"/>`;
    }
    return s;
  }

  function zenRingePat() {
    let s = `<rect width="60" height="60" fill="#E7E1D4"/>`;
    for (let r = 5; r <= 40; r += 7) s += `<circle cx="30" cy="30" r="${r}" fill="none" stroke="#B5AA93" stroke-width="2" opacity="0.75"/>`;
    return s;
  }

  function gritPat() {
    let s = `<rect width="60" height="60" fill="#DDD6C8"/>`;
    for (let i = 0; i < 90; i++) {
      const x = (i * 7.3) % 60;
      const y = (i * 11.7) % 60;
      s += `<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="0.7" fill="#B7AD97" opacity="0.6"/>`;
    }
    return s;
  }

  function knasttraePat() {
    let s=`<rect width="60" height="60" fill="#7A4E2C"/>`;
    [[12,18,8],[32,12,6],[22,36,9],[44,28,5],[8,48,6],[40,50,7]].forEach(([cx,cy,r])=>{
      for(let i=r;i>0;i-=2.5) s+=`<circle cx="${cx}" cy="${cy}" r="${i.toFixed(1)}" fill="none" stroke="#503018" stroke-width="0.9" opacity="${(0.1+i*0.04).toFixed(2)}"/>`;
    });
    return s;
  }
  function profileGlat() {
    return `<defs><linearGradient id="pg" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#E0D8D0"/><stop offset="100%" stop-color="#A09890"/></linearGradient></defs><rect width="60" height="60" fill="url(#pg)"/>`;
  }
  function profileRund() {
    return `<rect width="60" height="60" fill="#A09890"/><defs><radialGradient id="pr" cx="35%" cy="35%"><stop offset="0%" stop-color="#E0D8D0"/><stop offset="100%" stop-color="#706860"/></radialGradient></defs><rect x="8" y="8" width="44" height="44" rx="22" fill="url(#pr)"/>`;
  }
  function profileTrappet() {
    return `<rect width="60" height="60" fill="#707068"/><rect x="7" y="7" width="46" height="46" fill="#A8A098"/><rect x="15" y="15" width="30" height="30" fill="#C8C0B8"/><rect x="23" y="23" width="14" height="14" fill="#E0D8D0"/>`;
  }
  function profileIndreAccent() {
    return `<rect width="60" height="60" fill="#C0B8B0"/><rect x="8" y="8" width="44" height="44" fill="#D8D0C8"/><rect x="15" y="15" width="30" height="30" fill="#888078"/><rect x="21" y="21" width="18" height="18" fill="#C8C0B8"/><rect x="26" y="26" width="8" height="8" fill="#E0D8D0"/>`;
  }
  function aztecPat() {
    let s=`<rect width="60" height="60" fill="#1C0C04"/>`;
    for(let r=0;r<4;r++) for(let c=0;c<4;c++){const x=c*15,y=r*15,col=['#C8A24C','#A03010','#E0701A'][(r+c)%3];s+=`<polygon points="${x+7.5},${y+1} ${x+14},${y+7.5} ${x+7.5},${y+14} ${x+1},${y+7.5}" fill="${col}" opacity=".75"/>`;}
    return s;
  }
  function hjertePat() {
    let s=`<rect width="60" height="60" fill="#FFF0F0"/>`;
    [[8,6],[28,4],[48,6],[4,24],[22,20],[42,20],[52,24],[8,42],[28,38],[48,42]].forEach(([x,y])=>{s+=`<path d="M${x+4},${y+3} C${x+4},${y} ${x+8},${y} ${x+8},${y+2.5} C${x+8},${y} ${x+12},${y} ${x+12},${y+3} Q${x+12},${y+7} ${x+6},${y+10} Q${x},${y+7} ${x},${y+3} C${x},${y} ${x+4},${y} ${x+4},${y+3}Z" fill="#D03050" opacity=".65"/>`;});
    return s;
  }
  function blomsterbortPat() {
    let s=`<rect width="60" height="60" fill="#F5EEE5"/>`;
    [5,17,29,41,53].forEach(x=>{s+=`<circle cx="${x}" cy="6" r="4" fill="#C06080" opacity=".7"/><circle cx="${x}" cy="6" r="2" fill="#E090A0" opacity=".8"/><circle cx="${x}" cy="54" r="4" fill="#A04870" opacity=".7"/><circle cx="${x}" cy="54" r="2" fill="#C07090" opacity=".8"/>`;});
    s+=`<line x1="0" y1="16" x2="60" y2="16" stroke="#9B7060" stroke-width="0.6" opacity=".35"/><line x1="0" y1="44" x2="60" y2="44" stroke="#9B7060" stroke-width="0.6" opacity=".35"/>`;
    return s;
  }
  function rebPat() {
    let s=`<rect width="60" height="60" fill="#988070"/>`;
    for(let i=0;i<8;i++){const y=i*8;s+=`<path d="M0,${y+4} Q7.5,${y} 15,${y+4} Q22.5,${y+8} 30,${y+4} Q37.5,${y} 45,${y+4} Q52.5,${y+8} 60,${y+4}" stroke="#C8B090" stroke-width="2.5" fill="none" opacity=".8"/><path d="M0,${y+4} Q7.5,${y+8} 15,${y+4} Q22.5,${y} 30,${y+4} Q37.5,${y+8} 45,${y+4} Q52.5,${y} 60,${y+4}" stroke="#786050" stroke-width="2.5" fill="none" opacity=".7"/>`;}
    return s;
  }
  function geoStofPat() {
    let s=`<rect width="60" height="60" fill="#3A3A4A"/>`;
    for(let r=0;r<5;r++) for(let c=0;c<5;c++){const x=c*12,y=r*12;s+=`<polygon points="${x+6},${y} ${x+12},${y+6} ${x+6},${y+12} ${x},${y+6}" fill="${r%2===c%2?'#6070A0':'#4A5888'}" opacity=".65"/><line x1="${x}" y1="${y+6}" x2="${x+12}" y2="${y+6}" stroke="#7888B8" stroke-width="0.4" opacity=".5"/><line x1="${x+6}" y1="${y}" x2="${x+6}" y2="${y+12}" stroke="#7888B8" stroke-width="0.4" opacity=".5"/>`;}
    return s;
  }
  function monsteraPat() {
    let s=`<rect width="60" height="60" fill="#1A2810"/>`;
    const addLeaf=(cx,cy,sc)=>{s+=`<ellipse cx="${cx}" cy="${cy}" rx="${14*sc}" ry="${18*sc}" fill="#2A5018" opacity=".85"/><line x1="${cx}" y1="${cy-15*sc}" x2="${cx}" y2="${cy+15*sc}" stroke="#1A3810" stroke-width="${sc*1.5}" opacity=".6"/>`;[-5,-1,3,7].forEach(dy=>s+=`<ellipse cx="${cx+(dy>0?3:-3)*sc}" cy="${cy+dy*sc}" rx="${2.5*sc}" ry="${3.5*sc}" fill="#1A2810"/>`)};
    addLeaf(18,24,0.9); addLeaf(43,38,0.7);
    return s;
  }
  function sandPat() {
    let s=`<rect width="60" height="60" fill="#D4C490"/>`;
    for(let i=0;i<180;i++){const x=(i*37+7)%60,y=(i*23+11)%60,r=(i%5)*0.25+0.15;s+=`<circle cx="${x}" cy="${y}" r="${r}" fill="#B0A060" opacity="${(3+i%4)*0.1}"/>`;}
    return s;
  }
  function strikvarerPat() {
    let s=`<rect width="60" height="60" fill="#7A8898"/>`;
    for(let r=0;r<7;r++) for(let c=0;c<6;c++){const x=c*10+(r%2?5:0),y=r*9;s+=`<path d="M${x},${y+4} Q${x+2.5},${y} ${x+5},${y+4} Q${x+2.5},${y+8} ${x},${y+4}Z" fill="#9AAABB" opacity=".7"/><path d="M${x+5},${y+4} Q${x+7.5},${y} ${x+10},${y+4} Q${x+7.5},${y+8} ${x+5},${y+4}Z" fill="#6A7888" opacity=".7"/>`;}
    return s;
  }
  function kvGeoPat() {
    let s=`<rect width="60" height="60" fill="#2A2A2A"/>`;
    for(let r=0;r<4;r++) for(let c=0;c<4;c++){const x=c*15,y=r*15;s+=`<rect x="${x+1}" y="${y+1}" width="13" height="13" fill="none" stroke="#787878" stroke-width="1" opacity=".8"/><rect x="${x+4}" y="${y+4}" width="7" height="7" fill="none" stroke="#B0B0B0" stroke-width="0.7" opacity=".6"/><rect x="${x+6.5}" y="${y+6.5}" width="2" height="2" fill="#D8D8D8" opacity=".5"/>`;}
    return s;
  }
  function ornamentaltPat() {
    let s=`<rect width="60" height="60" fill="#1A1008"/>`;
    for(let r=0;r<6;r++) for(let c=0;c<7;c++){const x=c*10+(r%2?5:0),y=r*10;s+=`<circle cx="${x}" cy="${y}" r="3.5" fill="#C8A060" opacity=".7"/><circle cx="${x}" cy="${y}" r="2" fill="#E0C080" opacity=".6"/><circle cx="${x}" cy="${y}" r="0.7" fill="#F8E098" opacity=".85"/>`;}
    return s;
  }
  function gravertMetalPat() {
    let s=`<rect width="60" height="60" fill="#888898"/>`;
    for(let i=0;i<13;i++) s+=`<line x1="0" y1="${i*5}" x2="60" y2="${i*5}" stroke="#A0A0B0" stroke-width="${i%3===0?0.8:0.3}" opacity="${i%3===0?.55:.2}"/>`;
    s+=`<rect x="10" y="10" width="40" height="40" fill="none" stroke="#C0C0D0" stroke-width="1" opacity=".5"/><rect x="18" y="18" width="24" height="24" fill="none" stroke="#C0C0D0" stroke-width="0.7" opacity=".4"/><line x1="10" y1="10" x2="50" y2="50" stroke="#B0B0C0" stroke-width="0.5" opacity=".3"/><line x1="50" y1="10" x2="10" y2="50" stroke="#B0B0C0" stroke-width="0.5" opacity=".3"/>`;
    return s;
  }
  function artDecoPat() {
    return `<rect width="60" height="60" fill="#180E04"/><polygon points="30,4 56,22 56,38 30,56 4,38 4,22" fill="none" stroke="#C8A24C" stroke-width="1.1" opacity=".75"/><polygon points="30,11 50,25 50,35 30,49 10,35 10,25" fill="none" stroke="#C8A24C" stroke-width="0.7" opacity=".5"/><circle cx="30" cy="30" r="5" fill="none" stroke="#C8A24C" stroke-width="0.8" opacity=".6"/><line x1="30" y1="4" x2="30" y2="56" stroke="#C8A24C" stroke-width="0.4" opacity=".35"/><line x1="4" y1="30" x2="56" y2="30" stroke="#C8A24C" stroke-width="0.4" opacity=".35"/>`;
  }
  function snefnugPat() {
    const sf=(cx,cy,r)=>{let s='';for(let a=0;a<6;a++){const rad=a*Math.PI/3,x2=cx+Math.cos(rad)*r,y2=cy+Math.sin(rad)*r;s+=`<line x1="${cx}" y1="${cy}" x2="${x2.toFixed(1)}" y2="${y2.toFixed(1)}" stroke="#90C8F0" stroke-width="1" opacity=".8"/>`;const mx=cx+(x2-cx)*0.6,my=cy+(y2-cy)*0.6,pr=r*0.3;s+=`<line x1="${(mx+Math.cos(rad+Math.PI/2)*pr).toFixed(1)}" y1="${(my+Math.sin(rad+Math.PI/2)*pr).toFixed(1)}" x2="${(mx-Math.cos(rad+Math.PI/2)*pr).toFixed(1)}" y2="${(my-Math.sin(rad+Math.PI/2)*pr).toFixed(1)}" stroke="#90C8F0" stroke-width="0.6" opacity=".6"/>`;}s+=`<circle cx="${cx}" cy="${cy}" r="1.2" fill="#C8E8FF" opacity=".9"/>`;return s;};
    let s=`<rect width="60" height="60" fill="#0A1830"/>`;s+=sf(15,15,10);s+=sf(45,15,8);s+=sf(15,45,8);s+=sf(45,45,10);s+=sf(30,30,7);
    return s;
  }
  function zebraPat() {
    let s=`<rect width="60" height="60" fill="#F0EDE5"/>`;
    [0,11,20,29,38,47].forEach((x,i)=>{const w=i%2===0?7:5;s+=`<path d="M${x},0 Q${x+1.5},30 ${x+1},60 L${x+w},60 Q${x+w+1.5},30 ${x+w},0Z" fill="#1A1A1A" opacity=".9"/>`;});
    return s;
  }
  function skaelPat() {
    let s=`<rect width="60" height="60" fill="#2838A8"/>`;
    for(let r=0;r<8;r++) for(let c=0;c<7;c++){const x=c*9+(r%2?4.5:0),y=r*8;s+=`<ellipse cx="${x}" cy="${y+5}" rx="5" ry="5.5" fill="#4858C8" opacity=".7"/><ellipse cx="${x}" cy="${y+5}" rx="5" ry="5.5" fill="none" stroke="#7888E8" stroke-width="0.5" opacity=".5"/>`;}
    return s;
  }
  function floresPat() {
    let s=`<rect width="60" height="60" fill="#FFF5E8"/>`;
    [[12,14],[38,10],[8,38],[34,38],[54,26],[20,54],[50,52]].forEach(([cx,cy])=>{for(let a=0;a<6;a++){const rad=a*Math.PI/3,px=cx+Math.cos(rad)*7,py=cy+Math.sin(rad)*7;s+=`<circle cx="${px.toFixed(1)}" cy="${py.toFixed(1)}" r="4" fill="#E07080" opacity=".65"/>`;}s+=`<circle cx="${cx}" cy="${cy}" r="3" fill="#F0C040" opacity=".85"/>`;});
    return s;
  }
  function kaedepostPat() {
    let s=`<rect width="60" height="60" fill="#585868"/>`;
    for(let r=0;r<6;r++) for(let c=0;c<5;c++){const x=c*12+(r%2?6:0),y=r*10;s+=`<circle cx="${x+6}" cy="${y+5}" r="4.5" fill="none" stroke="#9898A8" stroke-width="1.5" opacity=".8"/><circle cx="${x+12}" cy="${y+5}" r="4.5" fill="none" stroke="#7888A0" stroke-width="1.5" opacity=".8"/>`;}
    return s;
  }
  function leopardPat() {
    let s=`<rect width="60" height="60" fill="#D4A038"/>`;
    [[9,8],[25,5],[46,10],[5,22],[20,26],[38,20],[53,24],[8,40],[24,44],[42,38],[55,48],[14,54],[36,52]].forEach(([x,y])=>{s+=`<circle cx="${x}" cy="${y}" r="3.8" fill="#4A2800" opacity=".5"/><circle cx="${x+3}" cy="${y+2}" r="2.5" fill="#3A1C00" opacity=".55"/><circle cx="${x-2}" cy="${y+3}" r="2" fill="#4A2800" opacity=".45"/>`;});
    return s;
  }
  function fiskPat() {
    const fish=(cx,cy,sc)=>`<path d="M${cx-8*sc},${cy} Q${cx},${cy-5*sc} ${cx+6*sc},${cy} Q${cx},${cy+5*sc} ${cx-8*sc},${cy}Z" fill="#4878B8" opacity=".75"/><path d="M${cx-8*sc},${cy} L${cx-13*sc},${cy-4*sc} L${cx-13*sc},${cy+4*sc}Z" fill="#3058A0" opacity=".7"/><circle cx="${cx+2*sc}" cy="${cy-1*sc}" r="${0.8*sc}" fill="#F0F0F0" opacity=".9"/>`;
    let s=`<rect width="60" height="60" fill="#082038"/>`;
    [[18,10,0.8],[42,7,0.7],[10,28,1],[35,24,0.85],[54,28,0.7],[18,46,0.9],[44,44,0.8]].forEach(([x,y,sc])=>s+=fish(x,y,sc));
    return s;
  }
  function kattePat() {
    const cat=(cx,cy,sc)=>{let s=`<ellipse cx="${cx}" cy="${cy+5*sc}" rx="${5.5*sc}" ry="${6.5*sc}" fill="#2A2A2A" opacity=".7"/><ellipse cx="${cx}" cy="${cy-1*sc}" rx="${5*sc}" ry="${5*sc}" fill="#2A2A2A" opacity=".7"/><polygon points="${cx-4*sc},${cy-5.5*sc} ${cx-2*sc},${cy-9*sc} ${cx},${cy-5.5*sc}" fill="#2A2A2A" opacity=".7"/><polygon points="${cx},${cy-5.5*sc} ${cx+2*sc},${cy-9*sc} ${cx+4*sc},${cy-5.5*sc}" fill="#2A2A2A" opacity=".7"/><circle cx="${cx-2*sc}" cy="${cy-2*sc}" r="${0.7*sc}" fill="#60B0D0" opacity=".9"/><circle cx="${cx+2*sc}" cy="${cy-2*sc}" r="${0.7*sc}" fill="#60B0D0" opacity=".9"/>`;return s;};
    let s=`<rect width="60" height="60" fill="#F5F0E8"/>`;
    [[12,22,0.8],[38,18,0.7],[8,46,0.85],[32,44,0.75],[52,37,0.7]].forEach(([x,y,sc])=>s+=cat(x,y,sc));
    return s;
  }
  function blomsterPat() {
    const flower=(cx,cy,r,c1,c2)=>{let s='';for(let a=0;a<5;a++){const rad=a*2*Math.PI/5,px=cx+Math.cos(rad)*r,py=cy+Math.sin(rad)*r;s+=`<circle cx="${px.toFixed(1)}" cy="${py.toFixed(1)}" r="${r*0.55}" fill="${c1}" opacity=".75"/>`;}s+=`<circle cx="${cx}" cy="${cy}" r="${r*0.38}" fill="${c2}" opacity=".9"/>`;return s;};
    let s=`<rect width="60" height="60" fill="#EEF8E8"/>`;
    s+=flower(12,12,7,'#E060A0','#F0C030');s+=flower(40,9,6,'#A040C0','#F0D030');s+=flower(55,30,5,'#D05080','#F0E040');s+=flower(20,40,8,'#C040A0','#F0C030');s+=flower(47,48,6,'#8040C0','#F0D040');s+=flower(6,52,5,'#D05080','#F0C030');
    return s;
  }
  function cupcakesPat() {
    const cup=(cx,cy,sc)=>`<rect x="${cx-5*sc}" y="${cy}" width="${10*sc}" height="${7*sc}" fill="#C07040" opacity=".85"/><polygon points="${cx-6*sc},${cy} ${cx-4*sc},${cy+3*sc} ${cx+4*sc},${cy+3*sc} ${cx+6*sc},${cy}" fill="#D09060" opacity=".75"/><ellipse cx="${cx}" cy="${cy}" rx="${5.5*sc}" ry="${3.5*sc}" fill="#F090A0" opacity=".9"/><ellipse cx="${cx-1*sc}" cy="${cy-1.5*sc}" rx="${2.5*sc}" ry="${2*sc}" fill="#FFB0C0" opacity=".65"/><circle cx="${cx}" cy="${cy-4*sc}" r="${sc}" fill="#FF3060" opacity=".9"/>`;
    let s=`<rect width="60" height="60" fill="#FFF0F5"/>`;
    [[10,36,0.85],[30,33,0.9],[50,36,0.85],[8,16,0.7],[50,14,0.7],[28,11,0.75]].forEach(([x,y,sc])=>s+=cup(x,y,sc));
    return s;
  }
  function bladePat() {
    const leaf=(x1,y1,x2,y2,c)=>{const cx=(x1+x2)/2,cy=(y1+y2)/2,dx=x2-x1,dy=y2-y1,len=Math.sqrt(dx*dx+dy*dy),nx=-dy/len*8,ny=dx/len*8;return `<path d="M${x1},${y1} Q${(cx+nx).toFixed(1)},${(cy+ny).toFixed(1)} ${x2},${y2} Q${(cx-nx*0.3).toFixed(1)},${(cy-ny*0.3).toFixed(1)} ${x1},${y1}Z" fill="${c}" opacity=".8"/>`;};
    let s=`<rect width="60" height="60" fill="#1A2A10"/>`;
    s+=leaf(5,56,18,14,'#3A6020');s+=leaf(14,60,28,8,'#508030');s+=leaf(28,56,46,6,'#3A6828');s+=leaf(44,60,55,18,'#4A7030');s+=leaf(0,36,28,4,'#2A5018');
    return s;
  }
  function juleornamentPat() {
    const orn=(cx,cy,r,c)=>`<circle cx="${cx}" cy="${cy}" r="${r}" fill="${c}" opacity=".85"/><ellipse cx="${cx+r*0.3}" cy="${cy-r*0.4}" rx="${r*0.25}" ry="${r*0.15}" fill="#FFFFFF" opacity=".4"/><line x1="${cx}" y1="${cy-r}" x2="${cx}" y2="${cy-r-5}" stroke="#806040" stroke-width="1.5" opacity=".8"/><rect x="${cx-3}" y="${cy-r-7}" width="6" height="3" rx="1" fill="#806040" opacity=".75"/>`;
    let s=`<rect width="60" height="60" fill="#0A1828"/>`;
    s+=orn(15,22,9,'#C81010');s+=orn(40,18,8,'#C8A010');s+=orn(54,36,7,'#1058C0');s+=orn(25,44,9,'#188018');s+=orn(48,52,7,'#A010A0');s+=orn(8,49,6,'#C84010');
    return s;
  }
  function girafPat() {
    let s=`<rect width="60" height="60" fill="#D4A838"/>`;
    [[7,5,3.5],[22,3,3],[36,7,4],[50,4,3],[4,18,3],[17,20,4.5],[32,16,3],[46,20,3.8],[11,33,3.5],[25,36,3],[41,32,3.8],[55,36,3],[7,50,3],[23,52,3.8],[40,48,3],[55,52,3.5]].forEach(([cx,cy,r])=>{s+=`<ellipse cx="${cx}" cy="${cy}" rx="${r}" ry="${r*1.25}" fill="#8A4A10" opacity=".78"/>`;});
    return s;
  }

  const PATTERNS = {
    'eg':             woodGrain('#C09060','#705028',10),
    'fyr':            woodGrain('#D4B870','#A08038',13),
    'knasttrae':      knasttraePat(),
    'hickory':        woodGrain('#8A5830','#4A2810',8),
    'valnoed':        woodGrain('#5E4630','#332414',11),
    'ahorn':          woodGrain('#E4C896','#B99860',12),
    'carrara':        marblePat('#EDEDEA','#9AA0A6'),
    'calacatta':      marblePat('#F4EFE6','#C8A24C'),
    'emperador':      marblePat('#5C4632','#D8C8B4'),
    'groen-onyx':     marblePat('#6E8B74','#E4EFE6'),
    'nero':           marblePat('#23211F','#E8E4DC'),
    'fint-hoer':      hoerPat(),
    'laerred':        hoerPat(),
    'silkesatin':     hoerPat(),
    'zen-ringe':      zenRingePat(),
    'fin-struktur':   gritPat(),
    'glat':           profileGlat(),
    'rund':           profileRund(),
    'trappet':        profileTrappet(),
    'indre-accent':   profileIndreAccent(),
    'aztec':          aztecPat(),
    'hjerte':         hjertePat(),
    'blomsterbort':   blomsterbortPat(),
    'reb':            rebPat(),
    'geo-stof':       geoStofPat(),
    'monstera':       monsteraPat(),
    'sand':           sandPat(),
    'strikvarer':     strikvarerPat(),
    'kv-geo':         kvGeoPat(),
    'ornamentalt':    ornamentaltPat(),
    'graveret-metal': gravertMetalPat(),
    'art-deco':       artDecoPat(),
    'snefnug':        snefnugPat(),
    'zebra':          zebraPat(),
    'skael':          skaelPat(),
    'flores':         floresPat(),
    'kaedepost':      kaedepostPat(),
    'leopard':        leopardPat(),
    'fisk':           fiskPat(),
    'katte':          kattePat(),
    'blomster':       blomsterPat(),
    'cupcakes':       cupcakesPat(),
    'blade':          bladePat(),
    'juleornamenter': juleornamentPat(),
    'giraf':          girafPat(),
    'smooth':         profileGlat(),
  };
  PATTERNS['wood-pro-oak'] = PATTERNS['eg'];
  PATTERNS['wood-pro-pine'] = PATTERNS['fyr'];

  /* Proeven som en adresse, saa den kan bruges som baggrundsbillede. */
  const cache = new Map();
  function svgFor(id) {
    const noegle = String(id || '');
    if (!Object.hasOwn(PATTERNS, noegle)) return null;
    if (cache.has(noegle)) return cache.get(noegle);
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">'
      + PATTERNS[noegle] + '</svg>';
    const adresse = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    cache.set(noegle, adresse);
    return adresse;
  }

  window.nfRammeMoenstre = Object.freeze({ svgFor, ider: () => Object.keys(PATTERNS) });
})();
